import { useAuthContext } from "providers/Auth";
import { Input } from "shared/components";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { RENT_PMS_SYNCED, RENT_PMS_UNSYNCED } from "../constants";
import { Register } from "shared/hooks";
import { PmsSyncOption } from "./PmsSyncOption";
import { PMSValue } from "./PmsValue";

export const UnitRentField = ({
  handleChange,
  values,
  register,
  rentType,
  id,
  label,
  placeholder,
  unitPmsId
}: {
  handleChange: any;
  values: any;
  register: Register;
  rentType: "monthly" | "home" | "site";
  id: string;
  label: string;
  placeholder?: string;
  unitPmsId?: string;
}) => {
  const { permissions, type } = useAuthContext();

  const isSyncedWithPms = values[`pms_${rentType}_rent_amount_override`];

  const pmsRentValues = values[`pms_${rentType}_rent_amount`];

  const handlePmsSync = (value: boolean) => {
    handleChange(`pms_${rentType}_rent_amount_override`)(value);

    handleChange(`${rentType}_rent_amount`)(
      values[`pms_${rentType}_rent_amount`] || 0
    );
  };

  return (
    <div className="grid grid-cols-2 gap-4 items-center">
      <div className="money-input-2">
        <Tooltip>
          <TooltipTrigger className="w-full text-left">
            <Input
              readOnly={
                !permissions.canChangeRentAmount ||
                Boolean(unitPmsId && isSyncedWithPms)
              }
              id={id}
              label={label}
              placeholder={placeholder}
              type="money"
              required
              {...register(`${rentType}_rent_amount`)}
            />
          </TooltipTrigger>

          {unitPmsId ? (
            <TooltipContent className="max-w-[320px] rounded-lg z-[50] border bg-alpha-800 p-4 text-sm text-white">
              <p>
                {values[`pms_${rentType}_rent_amount_override`]
                  ? RENT_PMS_SYNCED
                  : RENT_PMS_UNSYNCED}
              </p>
            </TooltipContent>
          ) : null}
        </Tooltip>
        {unitPmsId && type.isBoomScreen ? (
          <PmsSyncOption
            value={isSyncedWithPms}
            onChange={handlePmsSync}
            name={id}
          />
        ) : null}
      </div>

      <PMSValue value={pmsRentValues ? `$${pmsRentValues}` : ""} />
    </div>
  );
};
